/**
 * theKiss — cross-sell "Complete your look" tracking (cart drawer)
 *
 * Three events:
 *   upsell_view         — cart drawer opened AND the cross-sell slider is present (once per open) → denominator
 *   upsell_click        — user opens the quick-buy popup (image trigger or multi-variant "Add to Cart")
 *   upsell_add_to_cart  — product actually added from cross-sell (direct single-variant add OR add from inside popup)
 *
 * Wiring is delegation/event-based, so it survives the Swiper carousel re-rendering
 * and the cart drawer Section Rendering API HTML swaps.
 */
(function () {
  'use strict';

  function track(name, params) {
    if (window.gtag) gtag('event', name, params); // GA4 (primary)
    // if (window.klaviyo) klaviyo.push(['track', name, params]); // mirror to Klaviyo (optional)
    // if (window.fbq) fbq('trackCustom', name, params);          // Meta (optional)
  }

  var LOCATION = 'cart_drawer';

  // Pull product context off the nearest cross-sell card (set by snippets/product-card-cross-sell.liquid)
  function cardData(el) {
    var card = el && el.closest('[data-upsell-card]');
    if (!card) return {};
    return {
      product_id: card.dataset.productId || '',
      product_title: card.dataset.productTitle || '',
      product_handle: card.dataset.productHandle || '',
      price: parseFloat(card.dataset.productPrice) || undefined,
      variant_id: card.dataset.productVariant || ''
    };
  }

  // 1) upsell_view — once per drawer open, only if the slider rendered
  var viewFired = false;
  function fireView(drawer) {
    if (viewFired) return;
    var slider = drawer.querySelector('.cross-sell-slider');
    if (!slider) return;
    viewFired = true;
    track('upsell_view', {
      location: LOCATION,
      item_count: slider.querySelectorAll('[data-upsell-card]').length
    });
  }

  function bindDrawer(drawer) {
    if (!drawer || drawer.__upsellBound) return;
    drawer.__upsellBound = true;
    // <cart-drawer> dispatches these on itself (does not bubble) → listen directly
    drawer.addEventListener('dialog:after-show', function () { fireView(drawer); });
    drawer.addEventListener('dialog:after-hide', function () { viewFired = false; });
    // Already open at bind time (e.g. force_open_drawer after add)
    if (drawer.hasAttribute('open')) fireView(drawer);
  }

  function init() {
    bindDrawer(document.querySelector('#cart-drawer'));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Cart drawer HTML is swapped on cart updates; re-bind the (possibly new) element
  document.addEventListener('cart-drawer:refreshed', init);

  // 2) upsell_click — opening the quick-buy popup.
  //    Triggers: the image trigger, and the multi-variant button (it has aria-controls and opens the modal).
  //    The single-variant button is type=submit with NO aria-controls → excluded here → no double count.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '.cross-sell-slider__image-wrap--trigger, .cross-sell-slider__button[aria-controls]'
    );
    if (!trigger) return;
    track('upsell_click', cardData(trigger));
  });

  // 3) upsell_add_to_cart — fire on the REAL add (bubbling variant:add from the product form),
  //    only when it originates inside a cross-sell card or its quick-buy modal.
  //    Covers single-variant direct add and add-from-popup; uses cart line data for accuracy.
  document.addEventListener('variant:add', function (e) {
    var origin = e.target.closest(
      '[data-upsell-card], quick-buy-modal[id^="modal-cross-sell"]'
    );
    if (!origin) return;

    var item = (e.detail && e.detail.items && e.detail.items[0]) || {};
    var data = cardData(origin); // empty for relocated modals; fall back to line item below
    track('upsell_add_to_cart', {
      location: LOCATION,
      product_id: data.product_id || String(item.product_id || ''),
      product_title: data.product_title || item.product_title || '',
      variant_id: data.variant_id || String(item.variant_id || item.id || ''),
      price: data.price !== undefined ? data.price : (item.final_price || item.price || 0) / 100,
      quantity: item.quantity || 1
    });
  });
})();
